import { render, staticRenderFns } from "./batchCancel.vue?vue&type=template&id=275ee09f&"
import script from "./batchCancel.vue?vue&type=script&lang=ts&"
export * from "./batchCancel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports